export default "__VITE_ASSET__1067f685__"